module.exports = __webpack_public_path__ + "img/icon-skema.9c15dd9f.png";